import React, { Component } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

class BuildDate extends Component {
  render() {
    const buildData = useStaticQuery(graphql`
          query {
              currentBuildDate {
                  currentDate
              }
          }
      `);

    return (
      <div>
                  <p>
                      Last updated:
                      <br/>
                      {buildData.currentBuildDate.currentDate}
                  </p>
              </div>
    )
  }
}

export default BuildDate;
